export { useFeatureStaticMenu } from './use-feature-static-menu';
